import { useStore } from '@/utils/store';

export const useTreeBlocksGetters = () => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { getter } = useStore();
	return {
		// isInAppHelpEnabled: getter<boolean>(isInAppHelpEnabledGetter),
	};
};
